/* Ryse - Theoric: reconstroi o indicador do carrossel de Kits.
   PROBLEMA: o JS da section calcula as paginas cedo demais (antes do layout
   assentar) e gerava 1 bolinha para 3 telas de conteudo.
   SOLUCAO: fonte unica na geometria real do trilho (scrollWidth / clientWidth);
   o estado ativo vem sempre da rolagem, nunca do clique — assim indicador e
   conteudo nunca se desencontram.
   Sem requestAnimationFrame de proposito: e leitura de numero, e o rAF congela
   em abas de fundo. */
(function () {
  function iniciar() {
    var trilho = document.querySelector('.quiz-kits-showcase__track');
    var caixa = document.querySelector('[data-quiz-kits-dots]');
    if (!trilho || !caixa) return;

    var paginas = 1;

    function calcular() {
      var visivel = trilho.clientWidth;
      if (!visivel) return 1;
      return Math.max(1, Math.round(trilho.scrollWidth / visivel));
    }

    function indiceAtual() {
      var visivel = trilho.clientWidth;
      if (!visivel) return 0;
      var i = Math.round(trilho.scrollLeft / visivel);
      if (trilho.scrollLeft + visivel >= trilho.scrollWidth - 4) i = paginas - 1;
      return Math.min(Math.max(i, 0), paginas - 1);
    }

    function marcar() {
      var i = indiceAtual();
      var bts = caixa.children;
      for (var n = 0; n < bts.length; n++) {
        var ativo = n === i;
        bts[n].classList.toggle('is-active', ativo);
        if (ativo) bts[n].setAttribute('aria-current', 'true');
        else bts[n].removeAttribute('aria-current');
      }
    }

    function aoClicar(e) {
      var p = parseInt(e.currentTarget.dataset.pagina, 10) || 0;
      /* so rola: quem marca o ponto e o evento de scroll */
      trilho.scrollTo({ left: p * trilho.clientWidth, behavior: 'smooth' });
    }

    function montar() {
      var novas = calcular();
      if (novas === paginas && caixa.children.length === novas) { marcar(); return; }
      paginas = novas;
      caixa.textContent = '';

      if (paginas < 2) { caixa.setAttribute('hidden', ''); return; }
      caixa.removeAttribute('hidden');

      for (var i = 0; i < paginas; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'quiz-kits-showcase__dot';
        b.setAttribute('aria-label', 'Ir para grupo de kits ' + (i + 1));
        b.dataset.pagina = String(i);
        b.addEventListener('click', aoClicar);
        caixa.appendChild(b);
      }
      marcar();
    }

    trilho.addEventListener('scroll', marcar, { passive: true });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(montar, 150);
    }, { passive: true });

    montar();
    /* o tema tambem mexe nos pontos ao carregar; remonta depois que ele termina
       e de novo quando as imagens entram (o scrollWidth muda com elas) */
    setTimeout(montar, 300);
    setTimeout(montar, 900);
    window.addEventListener('load', function () { setTimeout(montar, 100); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();